import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import Barber from './components/Barber';
import withToggle from '../hoc/WithToggle';
import { showPasscode } from '../passcode';
import { getShopByRoute } from '../shops/selectors';

const mapStateToProps = (state, ownProps) => ({
  shop: getShopByRoute(state, ownProps.params.shopRoute),
});

export default compose(
  withRouter,
  connect(mapStateToProps, { showPasscode }),
  withToggle,
  withHandlers({
    onClick: props => (e) => {
      if (props.barber.requirePasscode) {
        e.preventDefault();
        props.showPasscode(props.barber.id);
      }
      if (props.onClick) props.onClick(e, props.barber, props.shop, props.link);
    },
  }),
)(Barber);



// WEBPACK FOOTER //
// ./src/app/barbers/Barber.js